import type { FaireProductEntity } from "../../entity_types/product";

export const p_pj6ztfyg3f: FaireProductEntity = {
  token: "p_pj6ztfyg3f",
  type: "product",
  name: "Tarot Card Magnetic Propagation Station",
  brandToken: "b_x9gc7rccbx",
  brandName: "Mars & Me",
  imageUrl:
    "https://cdn.faire.com/fastly/5a075981f004f7515506acd9441ea20ed2a9ca45d247f2277609ceb6a277c559.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8deaeb903382e32def37d2170d8b6fa2c64337cd765e5ab6bc7060859aefae1c.jpeg",
  ],
  priceDollars: 13.86,
  description:
    'Lasercut and engraved 5"x2.5" tarot card magnetic propagation station.',
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:31.065Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
